/* Detail + Car*/


//全局loading状态
export const SET_LOADING = 'SET_LOADING';
//全局loading状态
export const SET_HARDLOADING = 'SET_HARDLOADING';




// WEBPACK FOOTER //
// ./src/vuex/types.js